module.exports = __webpack_public_path__ + "media/country_flags/lk-400d9b78.png";